import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AttachPaymentMethodRequest,
  CreateStripeCustomerResponse,
  StripePaymentMethod
} from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class FacilityStripeService {
  private readonly http = inject(HttpClient);

  private getBaseUrl(facilityId: string): string {
    return `/api/facilities/${facilityId}/stripe`;
  }

  createCustomer(facilityId: string): Observable<CreateStripeCustomerResponse> {
    return this.http.post<CreateStripeCustomerResponse>(
      `${this.getBaseUrl(facilityId)}/customer`,
      {}
    );
  }

  attachPaymentMethod(
    facilityId: string,
    body: AttachPaymentMethodRequest
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.getBaseUrl(facilityId)}/payment-methods`,
      body
    );
  }

  getPaymentMethods(facilityId: string): Observable<StripePaymentMethod[]> {
    return this.http.get<StripePaymentMethod[]>(
      `${this.getBaseUrl(facilityId)}/payment-methods`
    );
  }
}
